import { TWallMaterial } from "lib/types";

export enum APIUserType {
  CUSTOMER = 'Customer',
  MANAGER = 'Manager',
  DIRECTOR = 'Director',
  CREATOR = 'Creator',
  CLIENT = 'Client',
  REALTOR = 'Realtor',
}

export enum EAvailabilityStatus {
  InAnalysis = 'InAnalysis',
  InModeration = 'InModeration',
  Rejected = 'Rejected',
  Available = 'Available',
  Archived = 'Archived',
}

export type TUserRole = TEmployeeRole | 'Client' | 'Realtor';

export type TEmployeeRole =
  | 'Director'
  | 'Creator'
  | 'Manager'
  | 'Lawyer'
  | 'Accountant'
  | 'Registrant'
  | 'Operator'
  | 'Logistician';

export type APIUserObj = {
  id: number;
  name?: string;
  firstName?: string;
  lastName?: string;
  email?: string;
  phone: string;
  type: APIUserType;
  forceAuthorize: string[];
  employeeRoles: TUserRole[];
};

export type APIBuilding = {
  floorCount: number;
  apartmentComplex: APIApartmentComplex | null;
};

export type APIPlan = {
  media: APIMedia;
};

export type APIApartmentComplex = {
  title: string;
  geoCity: APIGeoCity;
  geoStreet: APIGeoStreet | null;
  geoBuilding: APIGeoBuilding | null;
  geoDistrict: APIGeoDistrict | null;
};

export type APIMedia = {
  url: string;
};

export type APIApartmentRoomType = {
  id: number;
  fullTitle: string;
  shortTitle: string;
  roomCount: number;
  isStudio: boolean;
};

export interface CoordinatesSchema {
  latitude: number;
  longitude: number;
}

export interface PolygonSchema {
  id: number;
  coords: CoordinatesSchema[];
}

export type APIGeoCity = {
  name: string;
};

export type APIGeoStreet = {
  name: string;
  type: string;
};

export type APIGeoDistrict = {
  name: string;
};

export type APIGeoBuilding = {
  house: string | null;
};

export type APIApartmentItem = {
  id: number;
  floor: number;
  floorCount: number;
  roomCount: number;
  areaInSqM: number;
  apartmentComplexTitle: string;
  planImage: string | null;
  attachment: string | null;
  title: string | null;
  price: number;
  pricePerSqM: number;
  availabilityStatus: {
    key: string;
    translation: string;
  };
  marketType?: MarketTypes;
  buildingTitle: string;
};

export type APIApartmentItemLikable = APIApartmentItem & {
  isFavorite: boolean;
  notificationEnabled: boolean;
  isSavedInTemporaryFiles: boolean;
  hiddenUntil?: string;
  availabilityStatus?: { key: string; translation: string };
  originalFacilityId: number;
  buildingTitle: string;
};

export type APINotificationItem = APIApartmentItem & {
  isFavorite: boolean;
  notificationEnabled: boolean;
  notification: {
    id: number;
    isEnabled: boolean;
  };
};

export type TBuildingFacilityType = {
  commissioningQuarter: string;
  id: number;
  title: string;
  coordinates?: { latitude: number; longitude: number };
  wallMaterial?: TWallMaterial 
};

export type APIApartmentFull = APIApartmentItemLikable & {
  title: string;
  bedroomCount: number;
  ceilingHeight: number;
  images: string[];
  loweredPrice: number;
  hasMaternityCapital: boolean;
  hasBurden: boolean;
  minorOwners: boolean;
  building: TBuildingFacilityType;
  typeId?: number;
  platformAd?: {
    url: string;
    name: string;
  };
};

export enum APIDealRequestStatus {
  Opened = 'Opened',
  Active = 'Active',
  Pending = 'Pending',
  Cancelled = 'Cancelled',
  Postponed = 'Postponed',
  Closed = 'Closed',
}

export type APIRequestStatus = {
  name: string;
  value: APIDealRequestStatus;
};

export type APIApartmentComplexBuilding = {
  id: number;
  latitude: number;
  longitude: number;
};

export type APIFilterNotificationItem = APIApartmentItem & {
  isFavorite: boolean;
  notificationEnabled: boolean;
  notification: {
    id: number;
    isEnabled: boolean;
  };
  facility: APIApartmentItem & { isFavorite: boolean };
};

export enum MarketTypes {
  PRIMARY = 'Primary',
  SECONDARY = 'Secondary',
}
